import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { queryKeys, QUERY_CONFIG } from '../../lib/react-query'
import { ipsApi } from '../../services/api'
import { useAuthStore } from '../../store/authStore'


/**
 * Hook for fetching paginated IP addresses list
 * Automatically refetches when URL params change
 */
export function useIPs() {
  const orgId = useAuthStore((state) => state.orgId)
  const [searchParams] = useSearchParams()
  const params = searchParams.toString()

  return useQuery({
    queryKey: queryKeys.ips.list(orgId, params),
    queryFn: () => ipsApi.getList(params),
    enabled: !!orgId,
  })
}

/**
 * Hook for fetching IP filter options
 * Cached for 15 minutes as these change less frequently
 */
export function useIPFilterOptions() {
  const orgId = useAuthStore((state) => state.orgId)
  return useQuery({
    queryKey: queryKeys.ips.filterOptions(orgId),
    queryFn: () => ipsApi.getFilterOptions(),
    staleTime: QUERY_CONFIG.LISTS.staleTime,
    enabled: !!orgId,
  })
}

/**
 * Hook for fetching a single IP by ID
 * Optionally accepts custom_scan_ids parameter for historical data
 */
export function useIPDetail(id: string | null, customScanIds?: string) {
  const orgId = useAuthStore((state) => state.orgId)
  return useQuery({
    queryKey: queryKeys.ips.detail(orgId, id || '', customScanIds),
    queryFn: () => ipsApi.getById(id!, customScanIds),
    enabled: !!id && !!orgId,
  })
}
